class CustomerFieldsForm {
    constructor (theme, elem) {
        this._name = this.constructor.name
        this._theme = theme
        this._elem = elem
        this._submitButton = this._elem.querySelector('button[type="submit"]')
        this._successArea = this._elem.querySelector('[data-success-area]')
        this._errorArea = this._elem.querySelector('[data-error-area]')
        this._options = Object.assign({
            redirect: true,
            login: true,
            redirectUrl: '/account'
        }, JSON.parse(this._elem.dataset.ajaxForm ? this._elem.dataset.ajaxForm : '{}'))
    }

    onInit () {
        if (window.CF) {
            window.CF.customerReady(() => {
                this._elem.addEventListener('submit', e => {
                    e.preventDefault()
                    let valid = this._elem.reportValidity()
                    if (valid) {
                        this.submitForm()
                    }
                })
            })
        }
    }

    getFormValues () {
        let fields = this._elem.querySelectorAll('input[type="text"], input[type="hidden"], input[type="email"], input[type="tel"], input[type="checkbox"], input[type="radio"]:checked, textarea, select')
        let result = {}

        for (let field of fields) {
            if (field.hasAttribute('data-ignore') || field.getAttribute('name') === null) {
                continue
            }
            if (field.getAttribute('type') === 'checkbox') {
                result[field.getAttribute('data-column-key')] = field.checked
            } else {
                result[field.getAttribute('data-column-key')] = field.value
            }
        }
        console.log(result)
        return result
    }

    submitForm () {
        let values = this.getFormValues()
        this._elem.classList.add('loading')
        this._submitButton.setAttribute('disabled', 'disabled')
        let originalButtonContent = this._submitButton.textContent
        this._submitButton.textContent = 'Updating...'

        window.CF.customer.set(values)

        window.CF.customer.save(this._options)
            .then(() => {
                // Customer has been created! They will automatically be logged in and redirected to /account
            })
            .catch(error => {
                if (this._errorArea) {
                    this._submitButton.removeAttribute('disabled')
                    this._submitButton.textContent = originalButtonContent
                    this._errorArea.classList.remove('hide')
                    this._errorArea.innerHTML = error
                }
            })
    }
}

export default CustomerFieldsForm



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CustomerFieldsForm.js